import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { promotionByRevenue : { getPromotionByRevenue } } = apiUrls

export const PROMOTION_BY_REVENUE_SUCCESS = 'PROMOTION_BY_REVENUE_SUCCESS';
export const PROMOTION_BY_REVENUE_LOADING = 'PROMOTION_BY_REVENUE_LOADING';
export const TABLE_LOADING = 'TABLE_LOADING';

export const getPromotionByRevenueData = ({ fromYear, toYear,
    fromMonth, toMonth }) => async (dispatch) => {
    try{
        const requestData = {...getPromotionByRevenue, 
            data: {
                fromYear,
                toYear,
                fromMonth,
                toMonth                
            }
        };
        const data = await REQUEST(requestData);
        dispatch({
            type: PROMOTION_BY_REVENUE_SUCCESS,
            data,
        })
    }catch(e){
        dispatch({
            type: PROMOTION_BY_REVENUE_SUCCESS,
            data: {
              code: "",
              modal: null,
              notifications: null,
              paginationInfo : null
              }
          })
    }
}

export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: PROMOTION_BY_REVENUE_LOADING,
        isLoading
    })
}

export const handleTableLoader = isTableLoading => (dispatch) => {
    dispatch({
        type: TABLE_LOADING,
        isTableLoading
    })
}